import { withTranslation } from 'react-i18next';
import UploadButton from '@kopapro/components/commons/inputs/uploadButton/uploadButton';

export default withTranslation()(UploadButton);
